var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"prefers-light"},[_c('a',{on:{"click":_vm.forceColorSchemeDark}},[_vm._v("Lights on.")])]),_vm._v(" "),_c('div',{staticClass:"prefers-dark"},[_c('a',{on:{"click":_vm.forceColorSchemeLight}},[_vm._v("Lights off.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }